import {
  validateInput, validateInputOptional, logToConsole, skipValidateBasedOnTestInformation, isA4PCDevice
}
  from '../../Util';
import AppConstants from '_Constants/AppConstants';
import MusicConstants from '_Constants/MusicConstants';
import Utilities from './Utilities';
import CustomOptionsConstants from '../../_Constants/CustomOptionsConstants';
import { generateMapping } from './TestRunHelpers';
import { get_resources_required_by_location } from '../../Util/AQTTestOptionsParser';
import { sendRawInfoToNewRun, sendRawInfoToNewRunWithIdentifier, sendRawInfoToNewRunWithStateId } from './NewRunDataTransferUtils';
import {
  getErrorTextUtteranceRange, isInputOptional
} from './Util';
import { validateDeviceMapping } from './MappingGeneratorUtil';
import ld from 'lodash';

const MIN_KEYS_IN_CUSTOM_OPTIONS = 4; // what's the use? maybe validate customOptions key length

/**
 * onSmokeClickValidate original
 * TODO: validate for all test types, fill in parameters to be submitted to test run
 * onSmokeClickValidate
 * @param {*} selectedTestGroupInfo
 * @param {*} selectedTestGroupInfoError
 * @param {*} selectedTestGroupInfoErrorCallBack
 * @param {*} selectedScenario
 * @param {*} selectedScenarioCallBack
 * @param {*} selectedScenarioError
 * @param {*} scenarioErrorCallBack
 * @param {*} otherParams
 * @param {*} updateOtherParamsCallBack
 * @param {*} otherParamsError
 * @param {*} updateNewRunStateParameterCallBack
 */
export async function onAddTestClickValidate(selectedTestGroupInfo,
  selectedTestGroupInfoError,
  selectedTestGroupInfoErrorCallBack,
  selectedScenario,
  selectedScenarioCallBack,
  selectedScenarioError,
  scenarioErrorCallBack,
  otherParams,
  updateOtherParamsCallBack,
  otherParamsError,
  updateNewRunStateParameterCallBack) {
  // Generate mapping
  // need to wait until it's finished
  await generateMapping(selectedTestGroupInfo, selectedScenario, otherParams, updateOtherParamsCallBack);
  let submit = true;
  const identifier = 'ValidateStateBeforeAddTest, onAddTestClickValidate';
  
  /**
   * Modify the updatedScenario object and update state object in NewRun at the end.
   */
  let updatedScenario = selectedScenario;
  let updatedScenarioSelectionError = selectedScenarioError;
  updatedScenario.testOptions.resourcesRequired = get_resources_required_by_location(
    selectedScenario.testSuite,
    selectedScenario.scenarioType, selectedScenario.testType,
    selectedScenario.testOptions.customOptions, selectedScenario.marketPlace
  );
  updatedScenario.testOptions.scenarioType = selectedScenario.scenarioType;
  updatedScenario.testOptions.customOptions.deviceName = selectedTestGroupInfo.deviceName;
  updatedScenario.testOptions.customOptions.amazonId = selectedTestGroupInfo.deviceTypeId;
  updatedScenario.testOptions.customOptions.musiciHeartEmailAddr = selectedScenario.musiciHeartEmailAddr;
  updatedScenario.testOptions.testSuite = selectedScenario.testSuite;

  if ((AppConstants.SCENARIO_WITH_TEST_TYPES.includes(selectedScenario.scenarioType))
    && selectedScenario.testCategory !== AppConstants.DEVICE_LOCK_HANDS_FREE_VERIFICATION
    && !selectedScenario.testTypeArr.includes(true)){
    submit = false;
    updatedScenarioSelectionError.testTypeArr = true;
  }

  //TODO: deal with FAR custom later
  if (selectedScenario.scenarioType === AppConstants.FAR_CUSTOM) {
    submit = validateDeviceMappingHelper(otherParams, otherParamsError, updateNewRunStateParameterCallBack,
      selectedScenarioError, scenarioErrorCallBack);
  }

  // If it's a Customized test, Custom options should contain at lest one more key
  // besides just customizedTestType
  if ((selectedScenario.farFieldCustomOptionsSelected
    || selectedScenario.nearFieldCustomOptionsSelected
    || selectedScenario.automotiveCustomOptionsSelected)
    && Object.keys(selectedScenario.testOptions.customOptions).length < MIN_KEYS_IN_CUSTOM_OPTIONS) {
    submit = false;
    updatedScenarioSelectionError.testOptions = true;
  }

  // set testType if not set
  if (!AppConstants.SCENARIO_WITH_TEST_TYPES.includes(selectedScenario.scenarioType)
    && !MusicConstants.MUSIC_SCENARIOS.includes(selectedScenario.scenarioType)) {
    let testType = !selectedScenario.testType ? AppConstants.STANDARD : selectedScenario.testType;
    let isAcousticSuite = selectedScenario.testSuite === AppConstants.ACOUSTIC_SCENARIO_ID;
    // Only if scenario type is FAR, FAR Custom or WWDD, assign test type same
    // as scenario type
    if (isAcousticSuite) {
      testType = selectedScenario.scenarioType;
    }
    updatedScenario.testType = testType;
  }

  let whetherToSubmitBasedOnFieldValidation = validateEachField(selectedTestGroupInfo,
    selectedTestGroupInfoError,
    selectedScenario,
    selectedScenarioError,
    otherParams,
    updateOtherParamsCallBack,
    scenarioErrorCallBack,
    selectedTestGroupInfoErrorCallBack,
    selectedScenarioCallBack);

  if (! whetherToSubmitBasedOnFieldValidation) {
    submit = false;
  }

  // additional verifications for trained mobile
  if (selectedScenario.trainedMobileCustomOptionsSelected) {
    let trainersListEmpty = false;
    let schemeDefEmpty = false;
    if (selectedScenario.trainedUsers.length === 0) {
      submit = false;
      trainersListEmpty = true;
    }
    // eslint-disable-next-line no-prototype-builtins
    if (!selectedScenario.testOptions.customOptions.hasOwnProperty(CustomOptionsConstants.SCHEME_DEF_KEY)) {
      submit = false;
      schemeDefEmpty = true;
    }
    updatedScenarioSelectionError.trainedUsers = trainersListEmpty;
    updatedScenarioSelectionError.testOptions = schemeDefEmpty;
  }

  if ( selectedScenario.mobileVoiceRobustnessCustomOptionsSelected ) {
    let trainersListEmpty = false;
    let noisesListEmpty = false;
    let schemeDefEmpty = false;
    if (selectedScenario.trainedUsers.length === 0 || selectedScenario.noiseSelection.length === 0) {
      submit = false;
      trainersListEmpty = true;
      noisesListEmpty = true;

    }
    // eslint-disable-next-line no-prototype-builtins
    if (!selectedScenario.testOptions.customOptions.hasOwnProperty(CustomOptionsConstants.SCHEME_DEF_KEY)) {
      submit = false;
      schemeDefEmpty = true;
    }
    updatedScenarioSelectionError.trainedUsers = trainersListEmpty;
    updatedScenarioSelectionError.testOptions = schemeDefEmpty;
    updatedScenarioSelectionError.noiseSelection = noisesListEmpty;
  }

  // check if at least one of Test cases selected for wakeword in case of customized options
  if (selectedScenario.acousticWakewordCustomOptionsSelected) {
    let isFunctionalTestCasesEmpty = selectedScenario.functionalTestCases.length === 0;
    if (isFunctionalTestCasesEmpty) {
      submit = false;
    }
    updatedScenarioSelectionError.functionalTestCases = isFunctionalTestCasesEmpty;
  }

  // Morgan - Add isProcessAudioFiles
  if (selectedScenario.testSuite === AppConstants.AUTOMOTIVE_SCENARIO_ID) {
    updatedScenario.testOptions.customOptions.useCustomNoises = selectedScenario.useCustomNoises;
  }

  // TODO: deal with multimodal validation shortly
  // TODO: POC Only. Multimodal Scenario Type is not public yet.
  // Currently in AQT If this is Multimodal functional scenario, send "Custom Command" in Custom Options
  /* if (selectedScenario.scenarioType === AppConstants.MULTIMODAL_SCENARIO_ID) {
    let multiModalCustomCommand = this.state.testParams.multiModalCustomCommand;
    this.setState({
      testParams: {
        ...this.state.testParams,
        multiModalCustomCommand: AppConstants.EMPTY,
        testOptions: {
          ...selectedScenario.testOptions,
          customOptions: {
            ...selectedScenario.testOptions.customOptions,
            multiModalCustomCommand: multiModalCustomCommand,
            functionalTestCases: []
          }
        }
      }
    });
  } */

  // TODO: Auto Sync Resource should be Test group wise
  // If this is Acoustic scenario, send proxy & auto-sync settings value in custom options
  // Acoustic Specific operations
  if (selectedScenario.testSuite === AppConstants.ACOUSTIC_SCENARIO_ID) {
    let isProxyEnabled = selectedScenario.isProxyEnabled;
    let isAutoSyncEnabled = selectedScenario.isAutoSyncEnabled;

    updatedScenario.testOptions.customOptions.isProxyEnabled = isProxyEnabled;
    updatedScenario.testOptions.customOptions.isAutoSyncEnabled = isAutoSyncEnabled;
    updatedScenario.testOptions.customOptions.disablePlaybackSkill = selectedScenario.disablePlaybackSkill;
  }

  // If this is a Customized test, set Delay between utterances
  if (
    selectedScenario.testType === AppConstants.CUSTOMIZED &&
    selectedScenario.isDelayBetweenUtterancesChecked &&
    selectedScenario.delayBetweenUtterances > 0
  ) {
    const delayBetweenUtterances = selectedScenario.delayBetweenUtterances;
    updatedScenario.delayBetweenUtterances = delayBetweenUtterances;
    updatedScenario.testOptions.customOptions.delayBetweenUtterances = delayBetweenUtterances;
  }

  updatedScenario.testOptions.customOptions.deviceVirtualAssistant = selectedScenario.deviceVirtualAssistant;
  updatedScenario.testOptions.customOptions.disableAdminCheck = selectedScenario.disableAdminCheck;
  updatedScenario.testOptions.customOptions.retryEnabled = selectedScenario.retryEnabled;
  updatedScenario.testOptions.customOptions.disablePlaybackSkill = selectedScenario.disablePlaybackSkill;

  /**
   * Add WakewordModel to the testOptions if it is A4PC device
   */
  if (isA4PCDevice(selectedTestGroupInfo.deviceTypeId)) {
    updatedScenario.testOptions.customOptions.a4pcConfig = {
      'a4pcWakewordModel': ld.get(selectedScenario, 'a4pcWakewordModel', AppConstants.EMPTY),
      'aqtA4PCCompanionAppEnabled': ld.get(selectedTestGroupInfo, 'aqtA4PCCompanionAppEnabled', false),
      'a4pcDeviceConfigS3URL': ld.get(selectedTestGroupInfo, 'deviceConfig', AppConstants.EMPTY)
    }
  }

  sendRawInfoToNewRun(updatedScenario, selectedScenarioCallBack);
  sendRawInfoToNewRun(updatedScenarioSelectionError, scenarioErrorCallBack);

  logToConsole('TestLog - SelectedScenarios before submit = ' + JSON.stringify(selectedScenario));
  logToConsole('TestLog - selectedTestGroupInfo before submit = ' + JSON.stringify(selectedTestGroupInfo));
  logToConsole('TestLog - selectedScenarioError before submit = ' + JSON.stringify(selectedScenarioError));
  logToConsole('TestLog - otherParams before submit = ' + JSON.stringify(otherParams));
  return {
    isValid: submit,
    params: {
      selectedScenario: updatedScenario
    }
  };
}

// TODO: FAR Custom
/**
 * Validates device mapping before submitting the test
 * @return Returns true or false based on device mapping is valid or not
 * looks like redundant with MappingGeneratorUtil
 */
function validateDeviceMappingHelper(otherParams, otherParamsError, updateNewRunStateParameterCallBack,
  selectedScenarioError, scenarioErrorCallBack ) {
  const identifier = 'ValidateStateBeforeAddTest, validateDeviceMappingHelper';
  let deviceMapping = otherParams.deviceMapping;
  let submit = true;
  for (var dutKey in deviceMapping) {
    var dutKeyValue = deviceMapping[dutKey];
    for (var dutFieldKey in dutKeyValue) {
      var invalidInput = validateInputOptional(dutFieldKey, dutKeyValue[dutFieldKey]);
      if (invalidInput) {
        submit = false;
        this.setState({
          error: { ...this.state.error, [dutKey + '_' + dutFieldKey]: AppConstants.INPUTERR_INVALID_INPUT }
        });
        let updatedOtherParamsError = otherParamsError;
        updatedOtherParamsError[dutKey + '_' + dutFieldKey] = AppConstants.INPUTERR_INVALID_INPUT;
        sendRawInfoToNewRunWithStateId(identifier, updatedOtherParamsError, 'otherParamsError', updateNewRunStateParameterCallBack);
      }
    }
  }

  let errorMessage = validateDeviceMapping(deviceMapping);
  let updatedSelectedScenarioError = selectedScenarioError;
  updatedSelectedScenarioError.deviceMappingError = errorMessage;
  sendRawInfoToNewRunWithIdentifier(identifier, updatedSelectedScenarioError, scenarioErrorCallBack);
  return (errorMessage === AppConstants.EMPTY) ? submit : false;
}

/**
 * TODO: remove unused fields
 * Mainly deal with the errors during scenario selection
 * Hold for debugging in case other situations needs to be validated as well.
 * @param {*} selectedTestGroupInfo
 * @param {*} selectedScenario
 * @param {*} selectedScenarioError
 * @param {*} otherParams
 * @param {*} updateOtherParamsCallBack
 * @param {*} scenarioErrorCallBack
 * @param {*} selectedScenarioCallBack
 */
function validateEachField(selectedTestGroupInfo,
  selectedTestGroupInfoError,
  selectedScenario,
  selectedScenarioError,
  otherParams,
  updateOtherParamsCallBack,
  scenarioErrorCallBack,
  selectedTestGroupInfoErrorCallBack,
  selectedScenarioCallBack) {

  let testGroupInfoSlectionOK = validateFieldsOfObject(selectedTestGroupInfo, selectedScenario.testSuite,
    selectedScenario.scenarioType, selectedTestGroupInfoError, selectedTestGroupInfoErrorCallBack);
  let scenarioSelectionOK = validateFieldsOfObject(selectedScenario, selectedScenario.testSuite,
    selectedScenario.scenarioType, selectedScenarioError, scenarioErrorCallBack);
  return testGroupInfoSlectionOK && scenarioSelectionOK;
}

function validateFieldsOfObject(fields, testSuite, scenarioType, error, errorCallBack) {
  let readyForSubmit = true;
  let identifier = 'ValidateStateBeforeAddTest: validateFieldsOfObject';
  Object.keys(fields).forEach(key => {
    if (typeof fields[key] === 'string') {
      if (!skipValidateBasedOnTestInformation(key, testSuite, scenarioType)) {
        let isInputInvalid = isInputOptional(key, testSuite, scenarioType)
          ? validateInputOptional(key, fields[key])
          : validateInput(key, fields[key]);
        if (isInputInvalid) {
          readyForSubmit = false;
          let updatedError = error;
          updatedError[key] = true;
          sendRawInfoToNewRunWithIdentifier(identifier, updatedError, errorCallBack);
        }
      }
    }
  });
  return readyForSubmit;
}
